module.exports = __webpack_public_path__ + "img/pronged-driftwood-3.3745620b.jpg";